var map = {
	"./tech-excel.svg": 2054,
	"./tech-git.svg": 2055,
	"./tech-google-sheets.svg": 2056,
	"./tech-gray-chatgpt.svg": 1190,
	"./tech-gray-excel.svg": 1191,
	"./tech-gray-git.svg": 1192,
	"./tech-gray-google-sheets.svg": 1193,
	"./tech-gray-jupyter.svg": 1194,
	"./tech-gray-multiple.svg": 1195,
	"./tech-gray-other.svg": 1196,
	"./tech-gray-powerbi.svg": 1197,
	"./tech-gray-python.svg": 1198,
	"./tech-gray-r.svg": 1199,
	"./tech-gray-sql.svg": 1200,
	"./tech-gray-tableau.svg": 1201,
	"./tech-gray-theory.svg": 1202,
	"./tech-powerbi.svg": 2057,
	"./tech-python (2).svg": 2058,
	"./tech-python.svg": 2059,
	"./tech-r.svg": 2060,
	"./tech-responsive-artificial-intelligence.svg": 524,
	"./tech-responsive-chatgpt.svg": 548,
	"./tech-responsive-data.svg": 549,
	"./tech-responsive-excel.svg": 550,
	"./tech-responsive-git.svg": 551,
	"./tech-responsive-google-sheets.svg": 552,
	"./tech-responsive-jupyter.svg": 553,
	"./tech-responsive-langchain.svg": 554,
	"./tech-responsive-multiple.svg": 555,
	"./tech-responsive-powerbi.svg": 556,
	"./tech-responsive-powerpoint.svg": 557,
	"./tech-responsive-python.svg": 558,
	"./tech-responsive-r.svg": 559,
	"./tech-responsive-sql.svg": 560,
	"./tech-responsive-tableau.svg": 561,
	"./tech-responsive-theory.svg": 562,
	"./tech-sql.svg": 2061,
	"./tech-tableau.svg": 2062,
	"./tech-theory.svg": 2063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3856;